export const CONFIGURATION = {
    FPS_CONST: 29.97
};
